(function() {
    const adminGateway = '/query/admin-ajax.ashx';
    const crossOriginGateway = '/query/site-ajax.ashx';
    const publicGateway = '/query/public-ajax.ashx';

    // The following options are accepted:
    //   handler: name of handler
    //   action: name of action
    //   drfuhrmanSite: The domain to use in place of DRF.drfuhrmanSite for cross-origin requests (when crossOrigin is true)
    //   admin: Whether to use the admin gateway.
    //   crossOrigin: Whether to use the cross-origin gateway. Set to 'auto' to autodetect based on comparing the origin against DRF.drfuhrmanSite.
    //   csrf: If true, then a csrf token will be sent with non-cross-origin GET requests using a custom header.
    //   method: GET or POST. If not specifed, default is to use POST if there is a payload, or else GET.
    //   query: object with properties to send as query string arguments
    //   headers: object with properties to send as headers with the request
    //   payload: object to JSON stringified and sent as the body of the request
    //   keepalive: Boolean argument that is passed into the inner fetch call
    //   signal: optional AbortSignal
    //   cancelToken: for compatibility with axios - also takes an AbortSignal. Ignored if signal is set.
    //   cache: Only used for GET requests - this is passed through to the fetch call, except if it's exactly false it
    //          converts to no-store, and if it's exactly true it converts to default.
    //   successPredicate: Optional function to decide whether the result is successful after a response is received. The default predicate checks response.ok.
    //   successCallback: For ease of converting jquery code, this can be a callback that is invoked when the returned promise resolves.
    //                    The first argument is result.data, and the second argument is the result object itself.
    //   errorCallback: For ease of converting jquery code, this can be a callback that is invoked when the returned promise rejects.
    //                  The argument received is the result object the promise rejected with.
    //   finallyCallback: This is similar to the jquery complete callback, except it receives no argument like how Promise.finally works.
    // The returned object has the following properties:
    //   promise: a promise that resolves or rejects based on what happens with the ajax request
    //   cancel: a function that cancels the request when called - 'this' can be anything
    // The promise resolves or rejects with a result object containing the following properties:
    //   response: the response that came back, if any
    //   error: the error, if any - note if the request is aborted, this will be an Error of type DOMException, with name AbortError.
    //   data: the object resulting from parsing the response body as json
    //   cancelled: True if the request was cancelled
    window.dfajax = function(opt) {
        // This is the object that will be returned.
        var api = {};

        // Get the gateway, admin, and crossOrigin settings
        var admin = false;
        var crossOrigin = false;
        var gateway = publicGateway;
        if (opt.admin) {
            admin = true;
            gateway = adminGateway;
        } else if (opt.crossOrigin) {
            var drfuhrmanSite = (opt.drfuhrmanSite || (window.DRF && window.DRF.drfuhrmanSite) || '');
            if (opt.crossOrigin == 'auto') {
                if (drfuhrmanSite && window.origin.localeCompare(drfuhrmanSite, 'en', { usage: 'search', sensitivity: 'accent' }) != 0) {
                    crossOrigin = true;
                    gateway = drfuhrmanSite + crossOriginGateway;
                }
            } else {
                crossOrigin = true;
                gateway = drfuhrmanSite + crossOriginGateway;
            }
        }

        // Get the method
        var method = opt.method;
        if (!method) {
            method = (opt.payload? 'POST' : 'GET');
        } else {
            method = method.toUpperCase();
        }
        if (method !== 'GET' && method !== 'POST') {
            throw new Error('Invalid method');
        }

        // Get the query string arguments
        var query = new URLSearchParams();
        if (opt.query) {
            Object.entries(opt.query).forEach(function(entry) {
                query.set(entry[0], entry[1]);
            });
        }
        if (method === 'GET') {
            query.set('_h', opt.handler || '');
            query.set('_a', opt.action || '');
        } else {
            query.set('h', opt.handler || '');
            query.set('a', opt.action || '');
        }

        // Build the url
        var url = gateway + '?' + query.toString();

        // Get the payload, if any
        var payload = null;
        if (method === 'POST' && opt.payload) {
            payload = JSON.stringify(opt.payload);
        } else if (method === 'POST' && crossOrigin) {
            // Need a payload for the csrf token
            payload = '{}';
        }

        // Handle aborting.
        var abortController = new AbortController();
        if (opt.signal) {
            chainAbortSignal(abortController, opt.signal);
        } else if (opt.cancelToken) {
            chainAbortSignal(abortController, opt.cancelToken);
        }
        api.cancel = function(reason) {
            abortController.abort(reason);
        };

        // Build fetch options
        var fetchOptions = {
            method: method,
            headers: { },
            mode: 'same-origin',
            credentials: 'include',
            referrerPolicy: 'no-referrer-when-downgrade',
            signal: abortController.signal,
            keepalive: !!opt.keepalive,
        };
        if (crossOrigin) {
            fetchOptions.mode = 'cors';
        }
        if (method === 'GET') {
            if (opt.cache === false) {
                fetchOptions.cache = 'no-store';
            } else if (opt.cache === true) {
                fetchOptions.cache = 'default';
            } else if (opt.cache) {
                fetchOptions.cache = opt.cache;
            }
        }
        if (method === 'POST') {
            fetchOptions.cache = 'no-store';
            if (payload) {
                if (crossOrigin) {
                    // avoid preflight requests
                    fetchOptions.headers['Content-Type'] = 'text/plain';
                } else {
                    fetchOptions.headers['Content-Type'] = 'application/json';
                }
                fetchOptions.body = payload;
            }
        }
        if (opt.headers) {
            Object.entries(opt.headers).forEach(function(entry) {
                var key = entry[0];
                var value = entry[1];
                fetchOptions.headers[key] = value;
            });
        }

        // Decide whether to send a csrf token.
        var sendCsrfToken = false;
        if (method === 'POST') {
            sendCsrfToken = true;
        } else if (method === 'GET' && !crossOrigin && opt.csrf) {
            sendCsrfToken = true;
        }

        // Decide what means success
        var successPredicate = opt.successPredicate || function(result) {
            return result.response && result.response.ok;
        };

        // Get the callbacks
        var callbacks = {
            success: opt.successCallback,
            error: opt.errorCallback,
            finally: opt.finallyCallback,
        };

        // Get the promise going.
        api.promise = new Promise(function(resolve, reject) {
            var result = {};
            var promise;
            if (!sendCsrfToken) {
                promise = fetch(url, fetchOptions);
            } else {
                promise = getCsrfToken(admin, crossOrigin, gateway)
                    .then(function(token) {
                        if (crossOrigin) {
                            var body = JSON.parse(fetchOptions.body);
                            body.csrfToken = token;
                            fetchOptions.body = JSON.stringify(body);
                        } else {
                            fetchOptions.headers['X-DF-Ajax-Csrf-Token'] = token;
                        }
                        return fetch(url, fetchOptions);
                    });
            }
            promise
                .then(function(response) {
                    result.response = response;
                    if (parseMimeType(response.headers.get('Content-Type')) == 'application/json') {
                        return response.json();
                    } else {
                        return Promise.resolve(null);
                    }
                })
                .then(function(json) {
                    result.data = json;
                    if (successPredicate(result)) {
                        resolve(result);
                    } else {
                        reject(result);
                    }
                })
                .catch(function(error) {
                    if (error && error.name == 'AbortError') {
                        result.cancelled = true;
                    }
                    result.error = error || new Error();
                    reject(result);
                });
        });

        if (callbacks.success) {
            api.promise.then(function(result) {
                callbacks.success.call(null, result.data, result);
            });
        }

        if (callbacks.error) {
            api.promise.catch(function(result) {
                callbacks.error.call(null, result);
            });
        }

        if (callbacks.finally) {
            api.promise.finally(function() {
                callbacks.finally.call(null);
            });
        }

        return api;
    };

    var csrf = {
        admin: {
            token: null,
            expiration: 0
        },
        crossOrigin: {
            token: null,
            expiration: 0
        },
        public: {
            token: null,
            expiration: 0
        }
    };
    function getCsrfToken(admin, crossOrigin, gateway) {
        var state;
        if (admin) {
            state = csrf.admin;
        } else if (crossOrigin) {
            state = csrf.crossOrigin;
        } else {
            state = csrf.public;
        }
        if (state.expiration > Date.now()) {
            return Promise.resolve(state.token);
        } else {
            return new Promise(function(resolve, reject) {
                fetch(gateway + '?h=meta&a=get-csrf-token', {
                    method: 'POST',
                    mode: (crossOrigin? 'cors' : 'same-origin'),
                    credentials: 'include',
                    referrerPolicy: 'no-referrer-when-downgrade',
                })
                    .then(function(response) {
                        if (response.ok) {
                            return response.json();
                        } else {
                            return Promise.reject(new Error('Received a ' + response.status + ' response getting a csrf token'));
                        }
                    })
                    .then(function(data) {
                        // New expiration is token expiration minus 5 minutes
                        state.expiration = data.expiration - (5 * 60 * 1000);
                        state.token = data.token;
                        resolve(data.token);
                    })
                    .catch(function(error) {
                        reject(error);
                    });
            });
        }
    };

    function chainAbortSignal(abortController, signal) {
        if (!signal) {
            return;
        }

        if (signal.aborted) {
            abortController.abort(signal.reason);
        } else {
            signal.addEventListener('abort', function() {
                abortController.abort(signal.reason);
            });
        }
    }

    function parseMimeType(contentType) {
        // See: https://mimesniff.spec.whatwg.org/#parsing-a-mime-type
        contentType = String(contentType || '').trim();
        var m = /^([!#$%&'*+\-.^_`|~A-Z0-9]+\/[!#$%&'*+\-.^_`|~A-Z0-9]+)\s*(?:$|;)/i.exec(contentType);
        if (m) {
            return m[1].toLowerCase();
        } else {
            return null;
        }
    }

    // This is for easy conversion of existing code that uses axios.CancelToken.source()
    // It just wraps an AbortController.
    window.dfajax.CancelToken = {
        source: function() {
            var abortController = new AbortController();
            return {
                cancel: function() { abortController.abort(); },
                token: abortController.signal,
            };
        }
    };
})();